module.exports = __webpack_public_path__ + "static/assets/673f35faaa99f5329a67054d1829b033.gif";